module.exports = __webpack_public_path__ + "static/media/test_basic_formatting.fab41178.csv";